import React from 'react';
export const AccordionItemContext = React.createContext(null);
/**
 * @deprecated `useAccordionItem` is deprecated and will be removed in v25
 */
export const useAccordionItem = () => React.useContext(AccordionItemContext);
//# sourceMappingURL=AccordionItemContext.js.map